// extracted by mini-css-extract-plugin
export var closeButton = "_fd-2";
export var closeButtonIcon = "_fd-3";
export var lightboxContent = "_fd-1";
export var lightboxOverlay = "_fd-0";